<script setup lang="ts">
import { ref } from 'vue';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';
import { Textarea } from './ui/textarea';

const newOfferString = ref('');
const isOpen = ref(false);
const errorMessage = ref('');

const handleSubmitOffer = async (e: Event) => {
  e.preventDefault();
  errorMessage.value = ''; // Clear any previous error messages
  if (newOfferString.value.trim()) {
    try {
      const response = await fetch('https://api.dexie.space/v1/offers', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ offer: newOfferString.value.trim() }),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      console.log('Offer submitted successfully:', data);
      newOfferString.value = ''; // Clear the textarea after submission
      isOpen.value = false; // Close the dialog
    } catch (error) {
      console.error('Failed to submit offer:', error);
      errorMessage.value = error instanceof Error ? error.message : String(error);
    }
  }
};

const handleKeyDown = (e: KeyboardEvent) => {
  if (e.key === 'Enter' && !e.shiftKey) {
    e.preventDefault();
    handleSubmitOffer(e);
  }
};
</script>

<template>
  <Dialog v-model:open="isOpen">
    <DialogTrigger as-child>
      <Button>Submit Offer</Button>
    </DialogTrigger>
    <DialogContent>
      <DialogHeader>
        <DialogTitle class="dark:text-white">Submit Offer</DialogTitle>
        <DialogDescription> Paste your offer string below and submit it to the Splash network </DialogDescription>
      </DialogHeader>
      <form @submit="handleSubmitOffer">
        <Textarea placeholder="offer1..." v-model="newOfferString" @keydown="handleKeyDown" class="mb-4" />
        <DialogFooter>
          <Button type="submit">Submit Offer</Button>
        </DialogFooter>
        <p v-if="errorMessage" class="mt-2 text-sm text-red-600">{{ errorMessage }}</p>
      </form>
    </DialogContent>
  </Dialog>
</template>
